import { Icon } from '@billy/design-system'
import { Button, Menu } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useBalanceConfig, useBalanceLabels } from '@features/balanceLedger'
import { BalanceFilterType } from '@features/balanceLedger/enums/balanceFilterType'

import { SuppliersBalanceFilterType } from '../../enums/suppliersBalanceFilterType'

type AddFilterMenuProps = {
  availableTypes: SuppliersBalanceFilterType[]
  onOpen?: () => void
  onSelect: (type: SuppliersBalanceFilterType) => void
  triggerElement?: ReactElement
}

export const AddFilterMenu = ({
  availableTypes,
  onOpen,
  onSelect,
  triggerElement,
}: AddFilterMenuProps): ReactElement | null => {
  const { filterTypeMeta } = useBalanceConfig()
  const { bt } = useBalanceLabels()
  const { t } = useTranslation()

  if (availableTypes.length === 0) {
    return null
  }

  const handleSelect = (type: SuppliersBalanceFilterType) => () => {
    onSelect(type)
  }

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      onOpen?.()
    }
  }

  return (
    <Menu
      aria-label={bt('filters.action.add')}
      onOpenChange={onOpen ? handleOpenChange : undefined}
      placement="bottom-start"
      size="medium"
      trigger={triggerElement ?? <Button label={bt('filters.action.add')} size="small" variant="tonal" />}
    >
      {availableTypes.map((type) => (
        <Menu.Item
          key={type}
          icon={<Icon icon={filterTypeMeta[type as unknown as BalanceFilterType].icon} size="md" />}
          label={t(filterTypeMeta[type as unknown as BalanceFilterType].labelKey)}
          onClick={handleSelect(type)}
        />
      ))}
    </Menu>
  )
}
